/**
 * Needle and sharp (`needleandsharp`) submission rules.
 * Ten observation columns. Each column has a shift and 16 rows of 1/0/NA.
 */
import { UI_HIDDEN_DEPARTMENT_IDS } from './departmentUi';

export const NEEDLE_AND_SHARP_TITLE = 'เข็มตำ/ของมีคมบาด';
export const NEEDLE_AND_SHARP_OCCASION_COUNT = 10;

export type NeedleChecklistSection = {
  title: string;
  items: string[];
};

/** Section titles are not scored. 2.12 is a subsection title. 16 scored rows. */
export const NEEDLE_AND_SHARP_CHECKLIST: NeedleChecklistSection[] = [
  {
    title: '1 ก่อนทำหัตถการ',
    items: [
      '1.1 ประเมิน ผู้ป่วยก่อนทำกิจกรรม ขอความร่วมมือจากผู้ร่วมงานหรือญาติผู้ป่วยในการทำให้ผู้ป่วยสงบ หรือผูกมัดหากมีความจำเป็น',
    ],
  },
  {
    title: '2 ขณะทำหัตถการ',
    items: [
      '2.1 ห้ามสวมปลอกเข็มที่ใช้แล้วคืนกลับ',
      '2.2 ไม่ควรละสายตาจากเข็มหรือของมีคมและบริเวณตำแหน่งที่ทำหัตถการ',
      '2.3 นำกระป๋องทิ้งหัวเข็มไปด้วยทุกครั้งเพื่อทิ้งได้ทันที',
      '2.4 จัดให้กระป๋องทิ้งหัวเข็มอยู่ในตำแหน่งที่เหมาะสมและสะดวกต่อการใช้งาน',
      '2.5 ตรวจสอบกระป๋องทิ้งหัวเข็ม ว่าไม่มีเข็มค้างอยู่หรือปลายเข็มโผล่ขึ้นมา',
      '2.6 หากจำเป็นต้องปลดหัวเข็ม ใช้อุปกรณ์ปลดหัวเข็มทุกครั้ง เช่น Forceps',
      '2.7 เครื่องมือของมีคมต่างๆ ใช้ Forceps จับแทนการจับด้วยมือ',
      '2.8 ระวังการชน กระทบ กระแทกจากบุคคลที่อยู่ใกล้เคียง',
      '2.9 ไม่ส่งเข็มและ/ หรือ ของมีคมด้วยมือต่อมือโดยตรง',
      '2.10 หักหลอด Amp ยาโดย ใช้สำลีหรือก๊อสรอง',
      '2.11 ระมัดระวังการปักหลอด Hematocrit บนดินน้ำมัน',
    ],
  },
  {
    title: '2.12 การเย็บแผล',
    items: [
      '2.12.1 ไม่จับเข็มด้วยมือ ให้ใช้ clamps จับทุกครั้ง',
      '2.12.2 การใส่ใบมีด ให้ใช้ clamps จับใบมีดสวมเข้ากับด้ามมีด',
    ],
  },
  {
    title: '3 หลังทำหัตถการ',
    items: [
      '3.1 เก็บอย่างระมัดระวัง โดยใช้อุปกรณ์หยิบจับแทนการใช้มือและสวมถุงมือก่อนหยิบจับทุกครั้ง',
      '3.2 แยกเครื่องมือและอุปกรณ์แหลมคมให้ชัดเจน เพื่อความสะดวกและปลอดภัยในการล้างทำความสะอาด',
    ],
  },
];

/** Wards that do not submit needleandsharp. NSO and CSSD stay hidden app-wide. */
export const NEEDLE_AND_SHARP_EXCLUDED_DEPARTMENT_IDS = new Set<string>([
  ...UI_HIDDEN_DEPARTMENT_IDS,
  '21A',
  'STROKE',
  'BLO_BNK',
  'ECC',
]);

export function isNeedleAndSharpDepartmentExcluded(
  departmentId: string | null | undefined,
): boolean {
  if (!departmentId || typeof departmentId !== 'string') return false;
  const trimmed = departmentId.trim();
  if (!trimmed) return false;
  return NEEDLE_AND_SHARP_EXCLUDED_DEPARTMENT_IDS.has(trimmed);
}

export function isNeedleAndSharpCategory(value?: string | null): boolean {
  return value === 'needleandsharp' || value === NEEDLE_AND_SHARP_TITLE;
}
